export function noop() {}

export function createCoinThumbUrl(cryptoAssetsUrl, symbol) {
  return typeof symbol === 'string'
    && `${cryptoAssetsUrl}/media/${symbol.toLowerCase()}.svg`;
}

export function toLocaleString({ value, currencySymbol = null, fractionDigits = 0 }) {
  const numericValue = parseFloat(value);
  const defaultOptions = {
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  };
  let options = {
    ...defaultOptions,
  };

  if (currencySymbol != null) {
    options = {
      style: 'currency',
      currency: currencySymbol.toUpperCase()
    };
  }

  return numericValue.toLocaleString(undefined, options);
}

function mapCurrencySymbol({ currencySymbol, localeString }) {
  const map = {
    // TODO: uncomment the below once the design is suitable for more characters
    // 'AUD': ['A$', 'AUD$'],
    // 'USD': ['$', 'US$'],
  };

  const currencyMapping = map[currencySymbol];

  if (!currencyMapping) {
    return localeString;
  }

  const [nativeLocaleSymbol, customLocaleSymbol] = currencyMapping;
  const mappedLocaleString = localeString.replace(nativeLocaleSymbol, customLocaleSymbol);

  return mappedLocaleString;
}

export function toLocaleCurrencyString({ value, currencySymbol, fractionDigits }) {
  const localeString = toLocaleString({ value, currencySymbol, fractionDigits });

  return mapCurrencySymbol({ currencySymbol, localeString });
}

export function toLocaleNumericString({ value, fractionDigits = 0 }) {
  return toLocaleString({ value, fractionDigits });
}

export function getValueSign(numericValue) {
  if (numericValue > 0) {
    return '+';
  } else if (numericValue < 0) {
    return '-';
  }

  return null;
}

export function getValueVectorSybmol(numericValue) {
  if (numericValue > 0) {
    return '▲';
  } else if (numericValue < 0) {
    return '▼';
  }

  return '━';
}



// WEBPACK FOOTER //
// ./src/Shared/utils.js